import { render } from "./DashboardOrdersAll.vue?vue&type=template&id=783d5c16"
import script from "./DashboardOrdersAll.vue?vue&type=script&lang=js"
export * from "./DashboardOrdersAll.vue?vue&type=script&lang=js"

import exportComponent from "/vue-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__